import styled, { createGlobalStyle } from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { NavigationItems } from './NavigationItems';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScrollLock = createGlobalStyle({
  body: {
    overflow: 'hidden'
  }
});
const Backdrop = styled.div.withConfig({
  displayName: "MobileNavDrawer__Backdrop"
})(({
  theme
}) => ({
  position: 'fixed',
  inset: 0,
  backgroundColor: theme.color['specialty-scrim'],
  zIndex: 1000
}));
const DrawerContainer = styled.div.withConfig({
  displayName: "MobileNavDrawer__DrawerContainer"
})({
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  inlineSize: '280px',
  zIndex: 1001
});
export const MobileNavDrawer = ({
  isOpen,
  onClose
}) => {
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ScrollLock, {}), /*#__PURE__*/_jsx(Backdrop, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(DrawerContainer, {
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        backgroundColor: "fill-surface-default",
        borderInlineEndStyle: "solid",
        borderInlineEndColor: "border-transitional-core-subtle",
        borderInlineEndWidth: "100",
        paddingBlock: "400",
        paddingInline: "300",
        blockSize: "100%",
        children: /*#__PURE__*/_jsx(NavigationItems, {
          isExpanded: true,
          onNavigate: onClose
        })
      })
    })]
  });
};